import React from 'react';
import PropTypes from 'prop-types';
import { backgroundImage } from '../../../../utils/background-image';
import styles from '../../../../components/PromoIconography/PromoRoundel/Roundel/Roundel.scss';
import { useConfig } from '../../../../config/ContentComponentLibraryProvider';
const Roundel = ({ image }) => {
    const config = useConfig();
    return (React.createElement("div", { className: styles.wrapper, style: backgroundImage(image, config.cfDomain) },
        React.createElement("div", { className: styles.label }, image.altText)));
};
Roundel.propTypes = {
    image: PropTypes.object.isRequired,
};
export default Roundel;
//# sourceMappingURL=index.js.map